const videoEl = document.getElementById('js-hero-video')
const controlsEl = document.getElementById('js-hero-video-controls')
const taglineEl = document.getElementById('js-video-tagline')
const muteEl = document.querySelector('.js-video-mute')
const unMuteEl = document.querySelector('.js-video-unmute')
const pauseEl = document.querySelector('.js-video-pause')
const playEl = document.querySelector('.js-video-play')
const playElLarge = document.querySelector('.js-video-play-large')
const posterEl = document.querySelector('.js-video-poster')
const hiddenClass = 'u-hidden'

let sourceLoaded = false

function loadSource() {
  if (sourceLoaded) return Promise.resolve()
  const src = videoEl.getAttribute('data-src')
  if (!src) return Promise.resolve()
  return new Promise((resolve) => {
    videoEl.addEventListener('loadeddata', resolve, { once: true })
    videoEl.src = src
    videoEl.load()
    sourceLoaded = true
  })
}

const initPlayer = () => {
  muteEl.classList.add(hiddenClass)
  pauseEl.classList.add(hiddenClass)

  if (posterEl) {
    videoEl.addEventListener('playing', () => {
      posterEl.classList.add(hiddenClass)
    }, { once: true })
  }
}

const toggleAudio = () => {
  unMuteEl.classList.toggle(hiddenClass)
  muteEl.classList.toggle(hiddenClass)
}

const togglePlayback = () => {
  pauseEl.classList.toggle(hiddenClass)
  playEl.classList.toggle(hiddenClass)
  playElLarge.classList.toggle(hiddenClass)
  taglineEl.classList.toggle(hiddenClass)
}

const videoPlayer = () => {
  if (
    !taglineEl ||
    !muteEl ||
    !unMuteEl ||
    !pauseEl ||
    !playEl ||
    !playElLarge ||
    !videoEl ||
    !controlsEl
  ) {
    return
  }

  controlsEl.addEventListener('click', async (e) => {
    const target = e.target.closest('button')
    if (!target) return

    if (target === playEl || target === playElLarge) {
      await loadSource()
      togglePlayback()
      videoEl.play()
    } else if (target === pauseEl) {
      togglePlayback()
      videoEl.pause()
    } else if (target === muteEl) {
      toggleAudio()
      videoEl.muted = true
    } else if (target === unMuteEl) {
      toggleAudio()
      videoEl.muted = false
    }
  })

  // Preload source on hover or keyboard focus so playback starts instantly
  ;[playEl, playElLarge].forEach((btn) => {
    if (!btn) return
    btn.addEventListener('mouseenter', loadSource)
    btn.addEventListener('focus', loadSource)
  })

  initPlayer()
}

export default videoPlayer
